import styled from 'styled-components';
import { motion } from 'framer-motion';

export const WhatsAppButtonContainer = styled(motion.button)`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 60px;
  height: 60px;
  background: #25d366;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
  z-index: 1000;
  transition: all 0.3s ease;
  padding: 0;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: #20ba5a;
    box-shadow: 0 6px 16px rgba(37, 211, 102, 0.5);
    transform: translateY(-2px);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
    bottom: 20px;
    right: 20px;
  }

  @media (max-width: 480px) {
    width: 52px;
    height: 52px;
    bottom: 16px;
    right: 16px;
  }
`;

export const WhatsAppIcon = styled.svg`
  width: 32px;
  height: 32px;
  fill: #ffffff;
  pointer-events: none;

  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
  }

  @media (max-width: 480px) {
    width: 28px;
    height: 28px;
  }
`;

